/**
 * Типы модуля «Активность»: лента событий и тепловая карта.
 * Контракт — GET /api/user/activity и /api/dashboard/widgets/heatmap
 * (см. docs/openapi.yaml, тег User activity).
 */

import type { HeatmapPoint, UserStub } from '@/types/dashboard'

export type ActivityType =
  | 'lesson.completed_as_teacher'
  | 'lesson.completed_as_student'
  | 'test.completed'
  | 'homework.submitted'
  | 'homework.checked'
  | 'card.added'
  | 'card.trained'
  | 'subscription.purchased'
  | 'payment.refunded'
  | 'payment.marked_failed'
  | 'payment.marked_succeeded'
  | 'student.added'

/** Типы, доступные в фильтре (порядок = порядок чипов в UI) */
export const ACTIVITY_FILTER_TYPES: ActivityType[] = [
  'lesson.completed_as_teacher',
  'lesson.completed_as_student',
  'test.completed',
  'homework.submitted',
  'homework.checked',
  'card.trained',
  'card.added',
  'student.added',
]

export interface ActivityFeedItem {
  id: number
  type: ActivityType
  occurred_at: string
  title: string
  subtitle: string | null
  link: string | null
  user: UserStub | null
}

/**
 * События одного дня и типа. `count` — сколько всего, `items` — превью (до 3).
 * Группа может продолжиться на следующей странице курсора: склеиваем по date|type.
 */
export interface ActivityFeedGroup {
  date: string
  type: ActivityType
  title: string
  count: number
  occurred_at: string
  items: ActivityFeedItem[]
}

export interface ActivityFeedResponse {
  groups: ActivityFeedGroup[]
  from: string
  to: string
  next_cursor: string | null
  has_more: boolean
}

export interface ActivityFeedParams {
  userId?: number
  scope?: 'students'
  date?: string
  from?: string
  to?: string
  types?: ActivityType[]
  perPage?: number
  cursor?: string | null
}

export interface ActivityHeatmapResponse {
  user_id: number
  from: string
  to: string
  days: HeatmapPoint[]
}
